// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "ea5cdb8dc1ff51eba40b" + ".chunk.js";
};